import { All, GlobalFilterActionTypes } from './global-filter.action';
import { ToolbarTitleType } from '@enums/toolbar-title-type';
import { ToolbarTitleData } from '@models/toolbar-title-data';
import { getGlobalFilter } from './global-filter';

export interface GlobalFilter {
  items: any[];
  selected: any;
  disabled?: boolean;
}
export interface Filters {
  [key: string]: GlobalFilter;
}

export interface GlobalFilterState {
  title?: ToolbarTitleData;
  filters: Filters;
}

const loadInitialState = (): GlobalFilterState => {
  const data = getGlobalFilter();

  if (data) {
    return {
      title: {
        data: '',
        type: ToolbarTitleType.STRING,
      },
      filters: { ...data },
    };
  }

  return {
    title: {
      data: '',
      type: ToolbarTitleType.STRING,
    },
    filters: {},
  };
};

export function reducer(state = loadInitialState(), action: All): GlobalFilterState {
  switch (action.type) {
    case GlobalFilterActionTypes.DISABLE_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          companyIds: {
            ...state.filters.companyIds,
            disabled: action.payload.disableCompany,
          },
          groupIds: {
            ...state.filters.groupIds,
            disabled: action.payload.disableGroup,
          },
          optionIds: {
            ...state.filters.optionIds,
            disabled: action.payload.disableOptions,
          },
        },
      };
    }
    case GlobalFilterActionTypes.UPDATE_TITLE: {
      return {
        ...state,
        title: action.payload,
      };
    }
    default:
      return state;
  }
}
